import { Reducer } from 'redux'
import * as types from '../constantes/infoPages'

export type initialStateProps = {
  key: string
}

const initialState: initialStateProps = {
  key: ''
}

export const InfoPagesReducer: Reducer = (state: initialStateProps = initialState, action) => {
  switch (action.type) {
    case types.SET_KEY: {
      localStorage.setItem('key', JSON.stringify(action.payload))
      return { ...state, key: action.payload }
    }

    default:
      return state
  }
}
